import { useAtom } from "jotai";
import { atomFamily, atomWithStorage, useAtomValue } from "jotai/utils";

import * as flowConfig from "flows/market-mix-modelling/config";

const PREFIX = `${flowConfig.FLOW_NAME}/create`;

const overlayToBeShown = atomWithStorage(`${PREFIX}/show-create-overlay`, true);

export const useOverlayStatus = () => useAtom(overlayToBeShown);

export const useGetOverlayDisplay = () => useAtomValue(overlayToBeShown);

const inputFile = atomWithStorage<string>(`${PREFIX}/input-file`, null);

export const useInputFile = () => useAtom(inputFile);

export const useGetInputFile = () => useAtomValue(inputFile);

const timeColumn = atomFamily((fileId: string) =>
  atomWithStorage<string>(`${PREFIX}/${fileId}/input-file`, null)
);

export const useTimeColumn = () => {
  const fileId = useAtomValue(inputFile);
  return useAtom(timeColumn(fileId));
};

export const useGetTimeColumn = () => {
  const fileId = useAtomValue(inputFile);
  return useAtomValue(timeColumn(fileId));
};

const targetColumn = atomFamily((fileId: string) =>
  atomWithStorage<string>(`${PREFIX}/${fileId}/target-column`, null)
);

export const useTargetColumn = () => {
  const fileId = useAtomValue(inputFile);
  return useAtom(targetColumn(fileId));
};

export const useGetTargetColumn = () => {
  const fileId = useAtomValue(inputFile);
  return useAtomValue(targetColumn(fileId));
};

const groupingColumns = atomFamily((fileId: string) =>
  atomWithStorage<string[]>(`${PREFIX}/${fileId}/grouping-columns`, [])
);

export const useGroupingColumns = () => {
  const fileId = useAtomValue(inputFile);
  return useAtom(groupingColumns(fileId));
};

export const useGetGroupingColumns = () => {
  const fileId = useAtomValue(inputFile);
  return useAtomValue(groupingColumns(fileId));
};

const spendColumns = atomFamily((fileId: string) =>
  atomWithStorage<string[]>(`${PREFIX}/${fileId}/spend-columns`, [])
);

export const useSpendColumns = () => {
  const fileId = useAtomValue(inputFile);
  return useAtom(spendColumns(fileId));
};

export const useGetSpendColumns = () => {
  const fileId = useAtomValue(inputFile);
  return useAtomValue(spendColumns(fileId));
};

const activityColumns = atomFamily((fileId: string) =>
  atomWithStorage<string[]>(`${PREFIX}/${fileId}/activity-columns`, [])
);

export const useActivityColumns = () => {
  const fileId = useAtomValue(inputFile);
  return useAtom(activityColumns(fileId));
};

export const useGetActivityColumns = () => {
  const fileId = useAtomValue(inputFile);
  return useAtomValue(activityColumns(fileId));
};
